define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action/FormData",
	"csi/comm",
	"csi/locale",
	"csi/reflection",
	"csi/utility/stringUtility",
	"csi/wizard/ActionControllerMixin",
	"csi/widget/LabeledImage",
	"csi/xml",
	"./CreateColorwaysMixin",
	"./CreateStyleOrCandidateMixin",
	"./NewStylesFormController",
	"./NewStyleHelper",
	"Apparel/NewStyle",
	"Apparel/NewStyleForm",
	"Merchandising/NewProductVersionForm"
], function(declare, csi, _, FormData, comm, locale, reflection, {stringSubstitute}, ActionControllerMixin, LabeledImage, xml, CreateColorwaysMixin, CreateStyleOrCandidateMixin, NewStylesFormController, NewStyleHelper, NewStyle) {

	var CANDIDATE_QTY = "CandidateQuantity";
	var IS_STYLE_CANDIDATE = "IsStyleCandidate";
	var COLLECTION = "Collection";
	var TEMPLATE = "Template";
	var DESCRIPTION = "Description";
	var PRODUCTTYPE = "ProductType";
	var NUM_OF_DIGITS_PRODUCT = 3;
	var NUM_OF_DIGITS_OPTIONS = 3;
	var NUM_OF_DIGITS_STYLE_CANDIDATE = 2;

	return declare([NewStyle, ActionControllerMixin, CreateColorwaysMixin, CreateStyleOrCandidateMixin], {
		_fdProduct: null,
		_productUrls: null,

		// NewStyleHelper
		helper: null,

		constructor: function() {
			this.helper = new NewStyleHelper();
		},

		disableNext: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if on first page
			return index == 0 ? !page.getView().defView.getFieldValue("MerchProductCreateStyles") : true;
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if on first page
			return index ? false : page.getView().defView.getFieldValue("MerchProductCreateStyles");
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add appended rows to request
			return this.inherited(arguments, [urlsNew.concat(this._productUrls)]);
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return csi.transform(this._productUrls, function(url) {return this.m_cache.getNode(url);}, this) || [];
		},

		getSuccess: function() {
			return this.successMsg;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*Content*/currentPage,
							 /*Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var index = wizard.getIndexOfPage(nextPage);
			var fd;

			if (index == 0) {
				// MerchProduct form
				fd = this._fdProduct = this._fdProduct || new FormData(this);
			} else if (!bFinish) {
				// Style form
				fd = this.getFormData();

				// hide name field because name will come from MerchProduct
				var styleForm = nextPage.getView(wizard, {
					bAddHierarchyFields: true,
					formData: fd
				});

				styleForm.defView.removeField(xml.ATTR_NAME);

				if (styleForm.defView.getField(IS_STYLE_CANDIDATE) == null) {
					this._insertCandidateFields(styleForm);
				}

				if (styleForm.defView.getField("CreateColorways") == null) {
					this._insertColorwaysField(styleForm);
				}

				if (this._fdProduct.getFieldValue("MerchOptionQuantity") < 1) {
					styleForm.setFieldValue("CreateColorways", false);
					styleForm.setFieldDisabled("CreateColorways", true);
				} else {
					styleForm.setFieldDisabled("CreateColorways", false);
				}

			}

			return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd) : null;
		},

		process: function() {
			// summary: create Styles and add to specified Collection, then create MerchProducts and add to MerchCollection, then associate MerchProducts with Styles
			var qty = Number(this._fdProduct.getFieldValue("MerchProductQuantity"));
			var fName = this._fdProduct.getField(xml.ATTR_NAME);
			var namePattern = this._fdProduct.getFieldValue(xml.ATTR_NAME);
			var optionQty = Number(this._fdProduct.getFieldValue("MerchOptionQuantity"));
			var optionName = this._fdProduct.getField("MerchOptionName");
			var optionPattern = this._fdProduct.getFieldValue("MerchOptionName");
			var optionType = this._fdProduct.getFieldValue("MerchOptionType");
			var subtype = this._fdProduct.getFieldValue(reflection.ATTR_SUBTYPE);
			var bStyles = this._fdProduct.getFieldValue("MerchProductCreateStyles");
			var bStyleAsCandidate = this.getFormData().getFieldValue(IS_STYLE_CANDIDATE, true);
			var styleCandidateQty = Number(this.getFormData().getFieldValue(CANDIDATE_QTY, true));
			var collection = this.getFormData().getFieldValue(COLLECTION, true);
			var styleTemplate = this.getFormData().getFieldValue(TEMPLATE, true);
			var styleType = this.getFormData().getFieldValue(PRODUCTTYPE, true);
			var description = this.getFormData().getFieldValue(DESCRIPTION, true);
			var bCreateColorways = this.getFormData().getFieldValue("CreateColorways", true);
			var urlStyles = [];
			var urlOptions = [];
			var w = this.m_writer;
			var url = csi.EMPTY_URL;
			var name = "";
			var stylePattern = "";
			var styleName = "";

			if (!bStyleAsCandidate || styleCandidateQty < 1) {
				styleCandidateQty = 1;
			}

			let count = qty + (qty * styleCandidateQty) + (qty * optionQty);
			let newUrls = comm.createUrls(count);
			this._productUrls = [];
			this.m_typeNode = "Style";

			if (fName.isDefaultValue() && fName.hasExpression()) {
				namePattern = null;
			} else if ((qty > 1) && (namePattern.indexOf("${0}") < 0)) {
				namePattern += "-${0}";
			}

			if (optionName.isDefaultValue() && optionName.hasExpression()) {
				optionPattern = null;
			} else if ((optionQty > 1) && (optionPattern.indexOf("${0}") < 0)) {
				optionPattern += "-${0}";
			}

			if (styleCandidateQty > 1) {
				stylePattern += "-${0}";
			} else {
				stylePattern = null;
			}

			optionName = optionName.getValue();
			if (optionName == "") {
				optionName = fName.getValue();
			}

			for (var i = 0; i < qty; ++i) {
				let productUrl = newUrls[--count];
				this._productUrls.push(productUrl);
				if (namePattern) {
					name = stringSubstitute(namePattern, [`${i + 1}`.padStart(NUM_OF_DIGITS_PRODUCT, "0")]);
				}

				var styles = [];
				var styleNames = [];

				for (var j = 0; j < styleCandidateQty; ++j) {
					if (bStyles) {
						// create style
						if (stylePattern) {
							styleName = stringSubstitute(stylePattern, [`${j + 1}`.padStart(NUM_OF_DIGITS_STYLE_CANDIDATE, "0")]);
						}

						url = newUrls[--count];
						urlStyles.push(url);
						styles.push(url);
						styleNames.push(styleName);
					}
				}

				var options = [];
				var optionNames = [];

				for (var k = 0; k < optionQty; ++k) {
					// create options
					if (optionPattern) {
						optionName = stringSubstitute(optionPattern, [`${k + 1}`.padStart(NUM_OF_DIGITS_OPTIONS, "0")]);
					}

					url = newUrls[--count];
					urlOptions.push(url);
					options.push(url);
					optionNames.push(optionName);
				}

				w.callMethod("Merchandising", "CreateProductWithVersionAndStyles")
					.addParameter(xml.PROP_URL, xml.ATTR_REF, productUrl)
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlParent)
					.addParameter(xml.PROP_URL_FROM, xml.ATTR_CNLLIST, styles)
					.addParameter(xml.PROP_NAME, xml.ATTR_STRING, name)
					.addParameter(reflection.ATTR_SUBTYPE, xml.ATTR_REF, subtype)
					.addParameter("Legacy", xml.ATTR_ENUM, "MerchLegacy:New")
					.addParameter("TemplateURL", xml.ATTR_REF, styleTemplate)
					.addParameter("CollectionURL", xml.ATTR_REF, collection)
					.addParameter("StyleTypeURL", xml.ATTR_REF, styleType)
					.addParameter("NameSuffix", xml.ATTR_STRINGLIST, styleNames)
					.addParameter("Description", xml.ATTR_STRING, description)
					.addParameter("StyleAsCandidate", xml.ATTR_BOOLEAN, bStyleAsCandidate)
					.addParameter("OptionNameSuffix", xml.ATTR_STRINGLIST, optionNames)
					.addParameter("OptionsURL", xml.ATTR_CNLLIST, options)
					.addParameter("OptionSubtype", xml.ATTR_REF, optionType)
					.addParameter("CreateColorways", xml.ATTR_BOOLEAN, bCreateColorways);

			}

			if (qty >= 1) {
				// push all style attributes
				w.callMethod("Merchandising", "PushMappingAttributesToStyleForCreate")
					.addParameter("AddURLs", xml.ATTR_REFLIST, this._productUrls)
					.addParameter("StyleURLs", xml.ATTR_REFLIST, urlStyles);
			}

			// Apply changes to Style(s) based on the fields in the form
			this.helper._applyFormFieldsOnStyles(this, urlStyles, styleCandidateQty);

			// validate merch option nodes
			_.each(urlOptions, function(url) {
				w.validateNode(url, true);
			});

			// validate merch product version nodes
			_.each(this._productUrls, function(url) {
				w.validateNode(url, true);
			});


			this.m_typeNode = "MerchProduct";
			this.successMsg = locale.resource("NewProductVersion_Success", [qty]);
			this.publish();
		},

		toWriter: function() {
			var fd = this.getFormData();
			fd.getFieldValue(IS_STYLE_CANDIDATE, true);
			fd.getFieldValue(CANDIDATE_QTY, true);

			this.inherited(arguments);
		},

		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			if (wizard.getIndexOfPage(page) == 1) {
				defView.classController = NewStylesFormController;
			}
		},

		/**
		 * @override
		 * Add image to rightWidget
		 */
		onWizardViewCreate: function(wizard, page, view) {
			if (this.imageUrl) {
				view.rightWidgetProperties = {
					imageSrc: this.imageUrl,
				}
				view.rightWidgetClass = LabeledImage;
			}
		},
	});
});